import { AppProps } from 'next/app';

import 'styles/globals.css';
import 'styles/aoform.css';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import {Layout} from "../components/layout";
import {BlurMapContext} from "../context/blur-map-context";
import Script from "next/script";
import {useEffect, useState} from "react";
import {DictionaryContext} from "../context/dictionary-context";
import {useRouter} from "next/router";

export default function App({ Component, pageProps }: AppProps) {
  const {query} = useRouter();
  const [loadScripts, setLoadScripts] = useState<boolean>(false);
  const title = pageProps?.entity?.title || pageProps?.entity?.name || pageProps?.title;
  const menus = pageProps?.menus;

  useEffect(() => {
    const beginScripts = () => !loadScripts && setLoadScripts(true);
    window.addEventListener('mousemove', beginScripts);
    window.addEventListener('touchmove', beginScripts);
    return () => {
      window.removeEventListener('mousemove', beginScripts);
      window.removeEventListener('touchmove', beginScripts);
    }
  }, []);

  // Unregister service worker.
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      });
    }
  }, []);

  /**
   * Persist UTM.
   */
  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        const expiresInHours = (hours: number) => new Date().getTime() + (hours * 60 * 60 * 1000);
        if (query) {
          for (const key in query) {
            if (!key?.startsWith('utm_')) continue;
            localStorage.setItem(key, JSON.stringify({value: query[key], expires: expiresInHours(24)}));
          }
        }
      }
    }
    catch (e) {

    }
  }, [query]);

  // @ts-ignore
  return (
    <>
      <DictionaryContext.Provider value={pageProps?.dictionary}>
        <Layout title={title}
                menus={menus}
                loadScripts={loadScripts}
                webforms={pageProps?.webforms}
                metatag={pageProps?.metatag}
                entityInfo={pageProps?.entityInfo}
                newsletterPad={pageProps?.newsletterPad}
                customMenu={pageProps?.customMenu}
                alertBanner={pageProps?.alertBanner}
                contactFormTitle={pageProps?.contactFormTitle}
                contactFormDisplayTitle={pageProps?.contactFormDisplayTitle}
                contactFormDescription={pageProps?.contactFormDescription}
                logoScrollToTop={pageProps?.logoScrollToTop}
                hideUtilityMenu={pageProps?.hideUtilityMenu}
                hideFooterMenu={pageProps?.hideFooterMenu}
                redirectTo={pageProps?.redirectTo}
                dictionary={pageProps?.dictionary}
                translatedUrls={pageProps?.translatedUrls}
        >
          <BlurMapContext.Provider value={pageProps?.blurMap}>
            <Component {...pageProps} />
          </BlurMapContext.Provider>
        </Layout>
      </DictionaryContext.Provider>
      <script src="/js/acton/en/contact/form_embed.min.js" async={true} defer={true}></script>
      {process?.env?.NEXT_PUBLIC_GTM && (
        <Script
          id="google-tag-manager"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${process.env.NEXT_PUBLIC_GTM}');
          `,
          }}
        />
      )}
    </>
  )
}
